import React, { useState } from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@material-ui/core";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import { useDispatch, useSelector } from "react-redux";
import { roleNames } from "@icarius-utils/constants";
import { getUserData, getUserRoles } from "@icarius-app/selectors";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { changeRoleAction } from "@icarius-app/actions";
import { useHistory } from "react-router-dom";

const ChangeRoleDialog = (props) => {
    const { open, handleClose } = props;

    const [selectedRole, setSelectedRole] = useState("");

    const dispatch = useDispatch();
    const history = useHistory();
    const userRoles = useSelector(getUserRoles);
    const { level } = useSelector(getUserData);

    const handleSubmit = () => {
        if (!selectedRole) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("fieldRequeriment"), severity: "warning" }));
            return;
        }

        dispatch(changeRoleAction(selectedRole)).then((resp) => {
            if (resp.status === 200) {
                history.push("/");
            }
        });
        handleClose();
    };

    return (
        <Dialog open={open} PaperComponent={PaperDraggable} maxWidth={"xs"} fullWidth={true}>
            <div className={"dialog-container"}>
                <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                    {getLocalizedString("changeRole")}
                    <DialogTitleDivider />
                </DialogTitle>
                <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
                <DialogContent>
                    <Grid container item xs={12}>
                        <Grid container item alignItems="center" xs={12}>
                            <FormControl style={{ width: "100%" }}>
                                <InputLabel required id={`label`}>
                                    {getLocalizedString("documentRole")}
                                </InputLabel>
                                <Select
                                    value={selectedRole}
                                    labelId={`label`}
                                    id={`select`}
                                    onChange={(e) => setSelectedRole(e.target.value)}
                                    margin={"none"}
                                >
                                    {userRoles.map((item) => (
                                        <MenuItem
                                            className={"whiteText"}
                                            key={item}
                                            value={item}
                                            disabled={item === level} // si es el actual, ponerlo disabled
                                        >
                                            {getLocalizedString(roleNames[item])}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
                    <ButtonDialogAction isAccept onClick={handleSubmit} text={getLocalizedString("agree")} />
                </DialogActions>
            </div>
        </Dialog>
    );
};

export default ChangeRoleDialog;
